import { crm, wdn } from '@/apis/defineRouting.ts'
import { RouterName } from '@/routes/config.ts'

export const GLOBAL_ROLES = {
  //dashboard
  WATER_SUPPLY_AREA_SHOW_CHART: '/dashboard/water-supply-network/master-meter-data/show-chart',
  WATER_SUPPLY_AREA_SHOW_DETAIL: '/dashboard/water-supply-network/dmx/detail',
  MASTER_METER_QUANTITY_REPORT_SEARCH: '/dashboard/master-meter-quantity-report/search',
  MASTER_METER_QUANTITY_REPORT_EXPORT_EXCEL: '/dashboard/master-meter-quantity-report/export-excel',
  //phân vùng bản đồ
  MAP_PARTTION: '/map-partition',
  MAP_PARTTION_CREATE: '/map-partition/create',
  MAP_PARTTION_EXPORT_EXCEL: '/map-partition/export-excel',
  MAP_PARTTION_UPDATE: '/map-partition/update',
  MAP_PARTTION_DELETE: '/map-partition/delete',

  //khu vực cấp nước
  WATER_SUPPLY_AREA: '/water-supply-area',
  WATER_SUPPLY_AREA_CREATE: '/water-supply-area/create',
  WATER_SUPPLY_AREA_EXPORT_EXCEL: '/water-supply-area/export-excel',
  WATER_SUPPLY_AREA_UPDATE: '/water-supply-area/update',
  WATER_SUPPLY_AREA_UPDATE_STATUS: '/water-supply-area/update-status',
  WATER_SUPPLY_AREA_DELETE: '/water-supply-area/delete',
  WATER_SUPPLY_AREA_DETAIL: '/water-supply-area/detail',
  WATER_SUPPLY_AREA_MASTER_METER: '/water-supply-area/master-meter',
  WATER_SUPPLY_AREA_CYCLE: '/water-supply-area/cycle',
  WATER_SUPPLY_AREA_UPDATE_MASTER_METER: '/water-supply-area/update-master-meter',
  WATER_SUPPLY_AREA_UPDATE_CYCLE: '/water-supply-area/update-cycle',

  //đồng đồng tổng
  MASTER_METER: '/master-meter',
  MASTER_METER_CREATE: '/master-meter/create',
  MASTER_METER_EXPORT_EXCEL: '/master-meter/export-excel',
  MASTER_METER_UPDATE: '/master-meter/update',
  MASTER_METER_UPDATE_STATUS: '/master-meter/update-status',
  MASTER_METER_DELETE: '/master-meter/delete',
  MASTER_METER_DETAIL: '/master-meter/detail',
  MASTER_METER_SHOW_CHART: '/master-meter/show-chart',
  MASTER_METER_SHOW_DATA: '/master-meter/show-data',

  //tuyến ống
  PIPE: '/pipe',
  PIPE_CREATE: '/pipe/create',
  PIPE_EXPORT_EXCEL: '/pipe/export-excel',
  PIPE_UPDATE: '/pipe/update',
  PIPE_DELETE: '/pipe/delete',
  PIPE_DETAIL: '/pipe/detail',
  PIPE_IMPORT: '/pipe/import',
  PIPE_MC_CONFIRM: '/pipe/mc-confirm',
  PIPE_CORP_CONFIRM: '/pipe/corp-confirm',

  //datalogger
  DATA_LOGGER: '/datalogger',
  DATA_LOGGER_CREATE: '/datalogger/create',
  DATA_LOGGER_EXPORT_EXCEL: '/datalogger/export-excel',
  DATA_LOGGER_UPDATE: '/datalogger/update',
  DATA_LOGGER_UPDATE_STATUS: '/datalogger/update-status',
  DATA_LOGGER_DELETE: '/datalogger/delete',
  DATA_LOGGER_DETAIL: '/datalogger/detail',

  //sensor
  SENSOR: '/sensor',
  SENSOR_CREATE: '/sensor/create',
  SENSOR_EXPORT_EXCEL: '/sensor/export-excel',
  SENSOR_UPDATE: '/sensor/update',
  SENSOR_UPDATE_STATUS: '/sensor/update-status',
  SENSOR_DELETE: '/sensor/delete',
  SENSOR_DETAIL: '/sensor/detail',

  //van
  VALVE: '/valve',
  VALVE_CREATE: '/valve/create',
  VALVE_SEARCH: '/valve/search',
  VALVE_EXPORT_EXCEL: '/valve/export-excel',
  VALVE_UPDATE: '/valve/update',
  VALVE_UPDATE_STATUS: '/valve/update-status',
  VALVE_DELETE: '/valve/delete',
  VALVE_DETAIL: '/valve/self',
  VALVE_IMPORT: '/valve/import',

  VALVE_CONTROL: '/valve-control',
  VALVE_CONTROL_SEARCH: '/valve-control/search',
  VALVE_CONTROL_UPDATE: '/valve-control/update',
  VALVE_CONTROL_DELETE: '/valve-control/delete',
  VALVE_CONTROL_VIEW_DATA: '/valve-control/view-data',
  VALVE_CONTROL_HISTORY: '/valve-control/history-change',
  VALVE_CONTROL_DETAIL: '/valve-control-detail/search',

  VALVE_CONTROL_ORG_SELF: '/valve-control-org/self',
  VALVE_CONTROL_ORG_UPDATE_STATUS: '/valve-control-org/update-status',

  VALVE_CONTROL_DIARY: '/valve-control-his',
  VALVE_CONTROL_DIARY_SEARCH: '/valve-control-his/search',
  VALVE_CONTROL_DIARY_EXPORT_EXCEL: '/valve-control-his/export-excel',

  //Đồng hồ khách hàng
  METER_CUSTOMER_SEARCH: '/meter-customer/search',
  METER_CUSTOMER_CREATE: '/meter-customer/create',
  METER_CUSTOMER_UPDATE: '/meter-customer/update',
  METER_CUSTOMER_DELETE: '/meter-customer/delete',
  METER_CUSTOMER_UPDATE_STATUS: '/meter-customer/update-status',
  METER_CUSTOMER_EXPORT_EXCEL: '/meter-customer/export-excel',
  METER_CUSTOMER_IMPORT: '/meter-customer/import',

  //Dữ liệu tiêu thụ đồng hồ khách hàng
  METER_CUSTOMER_DATA_SEARCH: '/meter-customer-data/search',
  METER_CUSTOMER_DATA_UPDATE: '/meter-customer-data/update',
  METER_CUSTOMER_DATA_DELETE: '/meter-customer-data/delete',
  METER_CUSTOMER_DATA_EXPORT_EXCEL: '/meter-customer-data/export-excel',
  METER_CUSTOMER_DATA_IMPORT: '/meter-customer-data/import',

  //Sản lượng đồng hồ dma
  METER_QUANTITY_DMA_SEARCH: '/meter-quantity-data/search',
  METER_QUANTITY_DMA_VIEW_IMAGES: '/meter-quantity-data/view-images',
  METER_QUANTITY_DMA_UPDATE: '/meter-quantity-data/update',
  METER_QUANTITY_DMA_EXPORT_EXCEL: '/meter-quantity-data/export-excel',

  //Sản lượng đồng hồ nguồn cấp
  METER_QUANTITY_SOURCE_SEARCH: '/meter-quantity-data/search',
  METER_QUANTITY_SOURCE_VIEW_IMAGES: '/meter-quantity-data/view-images',
  METER_QUANTITY_SOURCE_UPDATE: '/meter-quantity-data/update',
  METER_QUANTITY_SOURCE_EXPORT_EXCEL: '/meter-quantity-data/export-excel',

  //Tổng hợp Sản lượng đồng hồ nguồn cấp

  GENERAL_MASTER_METER_DATA_SEARCH: '/meter-quantity-data/v2/search',
  GENERAL_MASTER_METER_DATA_UPDATE: '/meter-quantity-data/v2/update',
  GENERAL_MASTER_METER_DATA_EXPORT_EXCEL: '/meter-quantity-data/v2/export-excel',

  //Dữ liệu sản lượng nước cấp vào
  INPUT_PRODUCTION_DATA_SEARCH: '/input-production-data-dmx/search',
  INPUT_PRODUCTION_DATA_EXPORT_EXCEL: '/input-production-data-dmx/export-excel',

  //Dữ liệu sản lượng nước tiêu thụ
  CONSUMPTION_PRODUCTION_DATA_SEARCH: '/consumption-production-data-dmx/search',
  CONSUMPTION_PRODUCTION_DATA_EXPORT_EXCEL: '/consumption-production-data-dmx/export-excel',

  //khấu trừ thất thoát
  DMX_LOSS_DEDUCT_SEARCH: '/dmx-loss-deduct/search',
  DMX_LOSS_DEDUCT_UPDATE: '/dmx-loss-deduct/update',

  //các loại khấu trừ thất thoát
  LOSS_DEDUCT_TYPE_SEARCH: '/loss-deduct-type/search',
  LOSS_DEDUCT_TYPE_DETAIL: '/loss-deduct-type/self',
  LOSS_DEDUCT_TYPE_CREATE: '/loss-deduct-type/create',
  LOSS_DEDUCT_TYPE_UPDATE: '/loss-deduct-type/update',
  LOSS_DEDUCT_TYPE_DELETE: '/loss-deduct-type/delete',
  LOSS_DEDUCT_TYPE_EXPORT_EXCEL: '/loss-deduct-type/export-excel',

  //dữ liệu thất thoát theo khu vực
  DATA_LOSS_DMX_SEARCH: '/dmx-water-loss/search',
  DATA_LOSS_DMX_CALCULATE: '/dmx-water-loss/calculate',
  DATA_LOSS_DMX_SEARCH_GET_INFO_DMX: '/dmx-water-loss/input-production-data',
  DATA_LOSS_DMX_GET_MASTER_METER: '/dmx-water-loss/master-meter-data',
  DATA_LOSS_DMX_EXPORT_EXCEL: '/dmx-water-loss/export-excel',

  DASHBOARD_WATER_LOSS_CONFIG_SEARCH: '/dashboard-water-loss-config/search',
  DASHBOARD_WATER_LOSS_CONFIG_UPDATE: '/dashboard-water-loss-config/update',

  //áp lực theo khu vực
  DMX_PRESSURE_DATA_SEARCH: '/dmx-pressure-data/search',
  DMX_PRESSURE_DATA_DETAIL: '/dmx-pressure-data/self',

  //dữ liệu đồng hồ tổng:
  MASTER_METER_DATA: '/master-meter-data',
  MASTER_METER_DATA_HOUR: '/master-meter-data/hour',
  MASTER_METER_DATA_DAY: '/master-meter-data/day',
  MASTER_METER_DATA_DETAIL_DAY: '/master-meter-data/detail-day',
  MASTER_METER_DATA_MONTH: '/master-meter-data/month',
  MASTER_METER_DATA_DETAIL_MONTH: '/master-meter-data/detail-month',
  MASTER_METER_DATA_PRESSURE_FLOW: '/master-meter-data/pressure-flow-correlation',

  //Nhà máy nước
  WATER_FACTORY_SEARCH: '/factory/search',
  WATER_FACTORY_CREATE: '/factory/create',
  WATER_FACTORY_UPDATE: '/factory/update',
  WATER_FACTORY_DELETE: '/factory/delete',
  WATER_FACTORY_UPDATE_STATUS: '/factory/update-status',
  WATER_FACTORY_SELF: '/factory/self',
  WATER_FACTORY_EXPORT_EXCEL: '/factory/export-excel',
  WATER_FACTORY_SEARCH_DATALOGGER: '/factory-datalogger/search',
  WATER_FACTORY_GRANT_DATALOGGER: '/factory/grant-datalogger',
  WATER_FACTORY_UPDATE_STATUS_DATALOGGER: '/factory-datalogger/update-status',
  WATER_FACTORY_ASSIGN_DATA_LOGGER: '/factory-datalogger-p/search',
  WATER_FACTORY_ASSIGN_DATA_LOGGER_UPDATE: '/factory-datalogger-p/update',

  //Trạm xử lý
  TREATMENT_PLANT_SEARCH: '/treatment-plant/search',
  TREATMENT_PLANT_CREATE: '/treatment-plant/create',
  TREATMENT_PLANT_UPDATE: '/treatment-plant/update',
  TREATMENT_PLANT_DELETE: '/treatment-plant/delete',
  TREATMENT_PLANT_UPDATE_STATUS: '/treatment-plant/update-status',
  TREATMENT_PLANT_SELF: '/treatment-plant/self',
  TREATMENT_PLANT_EXPORT_EXCEL: '/treatment-plant/export-excel',
  TREATMENT_PLANT_SEARCH_DATALOGGER: '/treatment-plant-datalogger/search',
  TREATMENT_PLANT_GRANT_DATALOGGER: '/treatment-plant/grant-datalogger',
  TREATMENT_PLANT_UPDATE_STATUS_DATALOGGER: '/treatment-plant-datalogger/update-status',
  TREATMENT_PLANT_ASSIGN_DATALOGGER: '/treatment-plant-datalogger-p/search',
  TREATMENT_PLANT_ASSIGN_DATALOGGER_UPDATE: '/treatment-plant-datalogger-p/update',

  //Trạm tăng áp
  BOOSTER_STATION_SEARCH: '/booster-station/search',
  BOOSTER_STATION_CREATE: '/booster-station/create',
  BOOSTER_STATION_UPDATE: '/booster-station/update',
  BOOSTER_STATION_DELETE: '/booster-station/delete',
  BOOSTER_STATION_UPDATE_STATUS: '/booster-station/update-status',
  BOOSTER_STATION_SELF: '/booster-station/self',
  BOOSTER_STATION_EXPORT_EXCEL: '/booster-station/export-excel',
  BOOSTER_STATION_SEARCH_DATALOGGER: '/booster-station-datalogger/search',
  BOOSTER_STATION_GRANT_DATALOGGER: '/booster-station/grant-datalogger',
  BOOSTER_STATION_UPDATE_STATUS_DATALOGGER: '/booster-station-datalogger/update-status',
  BOOSTER_STATION_UPDATE_ASSIGN_DATALOGGER: '/booster-station-datalogger-p/update',
  BOOSTER_STATION_ASSIGN_DATALOGGER: '/booster-station-datalogger-p/search',

  //Quản lý khung giờ sử dụng nước
  MANAGE_TIME_WATER_SEARCH: '/hour-level/search',
  MANAGE_TIME_WATER_UPDATE: '/hour-level/update',
  MANAGE_TIME_WATER_EXPORT_EXCEL: '/hour-level/export-excel',

  //Danh mục cảnh báo
  ANOMALY_MONITORING_ALERT_GROUP_CREATE: '/alert-group/create',
  ANOMALY_MONITORING_ALERT_GROUP_SEARCH: '/alert-group/search',
  ANOMALY_MONITORING_ALERT_GROUP_UPDATE: '/alert-group/update',
  ANOMALY_MONITORING_ALERT_GROUP_EXPORT_EXCEL: '/alert-group/export-excel',
  ANOMALY_MONITORING_ALERT_GROUP_DETAIL: '/alert-group/detail',
  ANOMALY_MONITORING_ALERT_GROUP_DELETE: '/alert-group/delete',

  //Thống kê cảnh báo
  ANOMALY_MONITORING_ALERT_STATS: '/alert/stats',
  ANOMALY_MONITORING_ALERT_STATS_DMZ: '/alert/stats/dmz',
  ANOMALY_MONITORING_ALERT_STATS_DMX: '/alert/stats/dmx',
  ANOMALY_MONITORING_ALERT_STATS_BY_STAFF: '/alert/stats/staff',

  ANOMALY_MONITORING_ALERT_STATS_DNP: '/alert/stats/dnp',
  ANOMALY_MONITORING_ALERT_STATS_DNP_BY_ORG: '/alert/stats/dnp/stats-by-org',
  ANOMALY_MONITORING_ALERT_STATS_DNP_BY_ORG_LATEST: '/alert/stats/dnp/stats-by-org/latest',
  ANOMALY_MONITORING_ALERT_STATS_DNP_BY_TYPE: '/alert/stats/dnp/stats-by-type',

  ANOMALY_MONITORING_ALERT_STATS_BY_DMX: '/alert/stats/dmx',
  ANOMALY_MONITORING_ALERT_STATS_DMX_BY_ORG: '/alert/stats/dmx/stats-by-org',
  ANOMALY_MONITORING_ALERT_STATS_DMX_BY_ORG_LATEST: '/alert/stats/dmx/stats-by-type/latest',
  ANOMALY_MONITORING_ALERT_STATS_DMX_BY_TYPE: '/alert/stats/dmx/stats-by-type',

  //Bảng theo dõi sản lượng nền đêm
  TRACKING_PROD_NIGHTTIME_EXPORT_EXCEL: '/tracking-prod-nighttime/export_excel',
  TRACKING_PROD_NIGHTTIME_VIEW: '/tracking-prod-nighttime/tracking',

  //Danh sách cảnh báo
  ANOMALY_MONITORING_ALERT_SEARCH: '/alert/search',
  ANOMALY_MONITORING_ALERT_COMPARISON: '/alert/comparison-of-anomaly',
  ANOMALY_MONITORING_ALERT_DETAIL: '/alert/detail',
  ANOMALY_MONITORING_ALERT_EXPORT_EXCEL: '/alert/export-excel',
  ANOMALY_MONITORING_ALERT_UPDATE: '/alert/update',
  ANOMALY_MONITORING_ALERT_IN_PROGRESS: '/alert/change-state/inprogress',
  ANOMALY_MONITORING_ALERT_COMPLETED: '/alert/change-state/complete',
  ANOMALY_MONITORING_ALERT_REFUSE: '/alert/change-state/refuse',

  //Theo dõi bất thường
  ALERT_FLOW_DIFF: '/alert-flow-diff',
  ALERT_FLOW_DIFF_DETAIL: '/alert-flow-diff/detail',

  //Cảnh báo mất kết nối thiết bị
  DEVICE_CONNECT_LOSS_WARNING_EXPORT_EXCEL: '/alert-lost-connection/export-excel',

  //các loại khấu trừ thất thoát
  ADM_BOUNDARY_SEARCH: '/adm-boundary/search',
  ADM_BOUNDARY_DETAIL: '/adm-boundary/self',
  ADM_BOUNDARY_CREATE: '/adm-boundary/create',
  ADM_BOUNDARY_UPDATE: '/adm-boundary/update',
  ADM_BOUNDARY_DELETE: '/adm-boundary/delete',
  ADM_BOUNDARY_EXPORT_EXCEL: '/adm-boundary/export-excel',

  OPERATION_CONFIGURATION: '/operation/configuration',

  //Ngày nghỉ, lễ
  CALENDAR: '/operation/configuration/calendar',
  CALENDAR_SEARCH: '/operation/configuration/calendar/search',
  CALENDAR_HISTORY: '/operation/configuration/calendar/history',
  CALENDAR_UPDATE: '/operation/configuration/calendar/update',

  //Nhóm ticket
  TICKET_GROUP_UPDATE_STATUS: '/field-work/ticket-group/update-status',
  TICKET_GROUP_DETAIL: '/field-work/ticket-group/detail',
  TICKET_GROUP_UPDATE: '/field-work/ticket-group/update',
  TICKET_GROUP_DELETE: '/field-work/ticket-group/delete',
  TICKET_GROUP_SEARCH: '/field-work/ticket-group/search',
  TICKET_GROUP_CREATE: '/field-work/ticket-group/create',
  TICKET_GROUP_EXPORT_EXCEL: '/field-work/ticket-group/export-excel',
  TICKET_GROUP_SEARCH_TICKET_TYPE: '/field-work/ticket-group/search-ticket-type',

  //Loại ticket
  TICKET_TYPE_UPDATE_STATUS: '/field-work/ticket-type/update-status',
  TICKET_TYPE_DETAIL: '/field-work/ticket-type/detail',
  TICKET_TYPE_UPDATE: '/field-work/ticket-type/update',
  TICKET_TYPE_DELETE: '/field-work/ticket-type/delete',
  TICKET_TYPE_SEARCH: '/field-work/ticket-type/search',
  TICKET_TYPE_CREATE: '/field-work/ticket-type/create',
  TICKET_TYPE_EXPORT_EXCEL: '/field-work/ticket-type/export-excel',

  //Loại ticket theo đơn vị
  TICKET_TYPE_ORG_UPDATE_STATUS: '/field-work/ticket-type-org/update-status',
  TICKET_TYPE_ORG_DETAIL: '/field-work/ticket-type-org/self',
  TICKET_TYPE_ORG_UPDATE: '/field-work/ticket-type-org/update',
  TICKET_TYPE_ORG_DELETE: '/field-work/ticket-type-org/delete',
  TICKET_TYPE_ORG_SEARCH: '/field-work/ticket-type-org/search',
  TICKET_TYPE_ORG_CREATE: '/field-work/ticket-type-org/create',
  TICKET_TYPE_ORG_INIT: '/field-work/ticket-type-org/init',
  TICKET_TYPE_ORG_EXPORT_EXCEL: '/field-work/ticket-type-org/export-excel',
  TICKET_TYPE_ORG_TYPE_CONFIG: '/field-work/ticket-type-org/type-config',

  //Quản lý ticket
  TICKET_MANAGE_DETAIL: '/field-work/ticket/self',
  TICKET_MANAGE_PRINT: '/field-work/ticket/print',
  TICKET_MANAGE_PRINT_MATERIAL: '/field-work/ticket/print-material',
  TICKET_MANAGE_UPDATE: '/field-work/ticket/update',
  TICKET_MANAGE_DELETE: '/field-work/ticket/delete',
  TICKET_MANAGE_SEARCH: '/field-work/ticket/search',
  TICKET_MANAGE_CREATE: '/field-work/ticket/create',
  TICKET_MANAGE_EXPORT_EXCEL: '/field-work/ticket/export-excel',

  //Thông báo
  NOTI_APP_SEARCH: '/noti-app/search',
  NOTI_APP_CREATE: '/noti-app/create',
  NOTI_APP_DETAIL: '/noti-app/self',
  NOTI_APP_GET_COUNT_UNREAD: '/noti-app/count-unread',
  NOTI_APP_MARK_READ: '/noti-app/mark-read',

  //Quản lý khoán công việc
  PIECE_WAGE_MANAGE_SEARCH: '/piece-wage/search',
  PIECE_WAGE_MANAGE_CREATE: '/piece-wage/create',
  PIECE_WAGE_MANAGE_UPDATE: '/piece-wage/update',
  PIECE_WAGE_MANAGE_DELETE: '/piece-wage/delete',
  PIECE_WAGE_MANAGE_DETAIL: '/piece-wage/self',
  PIECE_WAGE_MANAGE_CONFIRM: '/piece-wage/confirm',
  PIECE_WAGE_MANAGE_UNCONFIRM: '/piece-wage/un-confirm',
  PIECE_WAGE_MANAGE_EXPORT_EXCEL: '/piece-wage/export-excel',
  PIECE_WAGE_STAFF_BY_TICKET_CALC: '/piece-wage-staff/calc'
}
export const WDN_MASTER_METER_MASTER_TYPE = {
  POWER_METER: 1,
  DMA: 2
}
export const WDN_MASTER_METER_MASTER_STATUS = {
  CONNECTED: 'IOT_DEVICE_CONNECTED',
  DISCONNECTED: 'IOT_DEVICE_DISCONNECTED'
}

export const WDN_MASTER_METER_TYPE = {
  MECHANICAL: 1,
  ELECTRONIC: 2
}

export const WDN_VALVE_TYPE = {
  ELECTRONIC: 1,
  MECHANICAL: 2
}

export const WDN_VALVE_FUNCTION_TYPE = {
  BORDER_VALVE: 1,
  STEP_VALVE: 2,
  CYCLIC_VALVE: 3,
  REDUCE_PRESSURE_VALVE: 4,
  AIR_EXHAUST_VALVE: 5,
  SLUDGE_VALVE: 6,
  LINE_BLOCK_VALVE: 7
}

export const WDN_PIPE_TYPE = {
  DISTRIBUTION: '1',
  TRANSMISSION: '2',
  SERVICE: '3'
}

export const WDN_FACTORY_TYPE = {
  FACTORY: 0,
  TREATMENT: 1,
  BOOSTER_STATION: 2
}

export const WDN_ALERT_GROUP_REFERENCE_TYPE = {
  ADJACENT_DAY: '1',
  DAY_OF_PREV_WEEKS: '2'
}
export const WDN_ALERT_GROUP_TYPE = {
  FLOW: '1',
  PRESSURE: '2',
  QUALITY: '3',
  LOST_CONNECTION: '4'
}
export const WDN_ALERT_GROUP_TYPE_VALUE = {
  FLOW: 'flow',
  REVERSE_FLOW: 'reverse_flow',
  BATTERY_CAPACITY: 'battery_capacity',
  INDEX: 'index',
  PRESSURE: 'pressure',
  VALVE_ANGLE: 'valve_angle',
  FORWARD_FLOW: 'forward_flow'
}
export const WDN_ALERT_ANOMALY_MONITORING = {
  ALERT_FLOW_DIFF: '1'
}

export const WDN_DEVICE_TYPE = {
  MASTER_METER: '1',
  DATALOGGER: '2',
  VALVE: '3',
  SENSOR: '4'
}

export const WDN_BOUNDARY_LEVELS = {
  LEVEL1: 1,
  LEVEL2: 2,
  LEVEL3: 3
}

export const CONFIG_TYPE_TICKET_BY_ORG = {
  PIECE_WORK: 1,
  COMMON: 2
}

export const WDN_HOUR_LEVEL = {
  PEAK: '1',
  IDLE: '2',
  OTHER: '3'
}

export const WDN_ALERT_STATE = {
  NEW: 1,
  SEEN: 2
}

export const ALERT_GROUP_TITLE = {
  TRACKING_PRODUCTION_NIGHTTIME: 'LL NĐ',
  SOURCE_FLOW_DIFF: 'CL NC',
  LOST_CONNECTION: 'Mất KNTB',
  FLOW_DIFF_SOURCE_METER_VS_MASTER_METER: 'CL NC-DMA'
}

export const ALERT_GROUP_FULL_TITLE = {
  TRACKING_PRODUCTION_NIGHTTIME: 'Cảnh báo lưu lượng nền đêm',
  SOURCE_FLOW_DIFF: ' Cảnh báo chênh lệch sản lượng nguồn cấp',
  LOST_CONNECTION: 'Cảnh báo mất kết nối thiết bị',
  FLOW_DIFF_SOURCE_METER_VS_MASTER_METER: 'Cảnh báo chênh lệch DMA-SubDMA'
}

export const ALERT_GROUP_CODE = {
  TRACKING_PRODUCTION_NIGHTTIME: 'TRACKING_PRODUCTION_NIGHTTIME',
  FLOW_DIFF_SOURCE_METER_VS_MASTER_METER: 'FLOW_DIFF_SOURCE_METER_VS_MASTER_METER',
  SOURCE_FLOW_DIFF: 'SOURCE_FLOW_DIFF',
  LOST_CONNECTION: 'LOST_CONNECTION',
  PRESSURE_WARNING: 'PRESSURE_WARNING'
}

export const ALERT_STATE = {
  NEW: 1,
  SEEN: 2,
  PROCESS: 3,
  COMPLETE: 4,
  REJECT: 5
}

export const ALERT_STATE_CODE = {
  PROCESSED: 'processed',
  PROCESSING: 'processing',
  UN_PROCESSED: 'unProcessed'
}

export const VALUE_TYPE_LOSS_DEDUCT = {
  LOSS_DEDUCT: 1,
  LOSS_DEDUCT_BY_METER: 2
}

export const TYPE_METER = [
  { label: 'Cấp vào', value: 1 },
  { label: 'Cấp ra', value: 2 }
]

export const TYPE_MASTER_METER = {
  SOURCE: 1, //ĐH Nguồn cấp
  DMA: 2 //ĐH DMA
}

export const WDN_CALENDAR_CONFIG_DATE_TYPE = {
  HOLIDAY: 1,
  WORKING_DAY: 2
}

export const WDN_CALENDAR_CONFIG_REV_TYPE_TITLE = {
  0: 'Tạo mới',
  1: 'Cập nhật',
  2: 'Xóa'
}

export const WDN_METER_QUANTITY_CHANGE_TYPE_TITLE = {
  0: 'Tạo mới',
  1: 'Cập nhật',
  2: 'Xóa'
}

export const TICKET_CHANGE_TYPE_TITLE = {
  0: 'Tạo mới',
  1: 'Cập nhật',
  2: 'Xóa'
}

export const WDN_METER_QUANTITY_CHANGE_TYPE_DATA = {
  production: 'Số lượng tiêu thụ',
  beginValue: 'Chỉ số đầu',
  endValue: 'Chỉ số cuối',
  beginTime: 'Thời gian đo đầu kì',
  endTime: 'Thời gian đo cuối kì'
}

export const TICKET_CHANGE_TYPE_DATA = {
  state: 'Trạng thái',
  dueTime: 'Thời hạn xử lý',
  priority: 'Mức độ ưu tiên',
  lng: 'Kinh độ',
  lat: 'Vĩ độ'
}

export const WDN_VALVE_CONTROL_CONFIG = {
  1: {
    name: 'P',
    prev: 'prevPressure',
    update: 'pressure'
  },
  2: {
    name: 'Q',
    prev: 'prevFlow',
    fieldUpdate: 'flow'
  },
  3: {
    name: 'V',
    prev: 'prevAngle',
    update: 'angle'
  }
}

export const WDN_VALVE_CONTROL = {
  PRESSURE: 1,
  FLOW: 2,
  ANGLE: 3
}

export const MODE_ACTION_TO_PAGE = {
  VIEW: '0',
  EDIT: '1',
  CREATE: '2'
}

export const MODE_DISPLAY_INFO_MASTER_METER = {
  SHORT_INFO: 1,
  FULL_INFO: 2
}

export const OBJECT_TYPE_CODE = {
  CRM_CUSTOMER: crm.CUSTOMER_SEARCH,
  PIPE: wdn.PIPE_SEARCH,
  MASTER_METER: wdn.MASTER_METER_SEARCH,
  VALVE: wdn.VALVE_CATALOG_SEARCH,
  DATALOGGER: wdn.DATALOGGER_SEARCH,
  SENSOR: wdn.SENSOR_SEARCH
}

export const OBJECT_CODE_DETAIL = {
  PIPE: wdn.PIPE_DETAIL,
  MASTER_METER: wdn.MASTER_METER_DETAIL,
  VALVE: wdn.VALVE_CATALOG_DETAIL,
  DATALOGGER: wdn.DATALOGGER_DETAIL,
  SENSOR: wdn.SENSOR_DETAIL
}

export const OBJECT_TYPE = {
  CRM_CUSTOMER: '1',
  PIPE: '2',
  MASTER_METER: '3',
  VALVE: '4',
  DATALOGGER: '6',
  SENSOR: '5',
  OTHER: '7'
}

export const OVER_DUE_LIST = [
  { label: 'Trong hạn', value: 0 },
  { label: 'Quá hạn', value: 1 }
]

export const CALCULATE_PIECEWORK_SALARY_LIST = [
  { label: 'Có tính lương khoán', value: true },
  { label: 'Không tính lương khoán', value: false }
]

export const TICKET_STATE = {
  NEW: 1,
  PROCESS: 2,
  COMPLETE: 3,
  CANCEL: 4
}

export const CALENDAR_LIST_TICKET_ORG = {
  MON: 'Thứ 2',
  TUE: 'Thứ 3',
  WED: 'Thứ 4',
  THU: 'Thứ 5',
  FRI: 'Thứ 6',
  SAT: 'Thứ 7',
  SUN: 'Chủ nhật'
}

export const OBJECT_TYPE_ON_MAP = {
  DMA: 0,
  METER_C: '1',
  PIPE: '2',
  MASTER_METER: '3',
  VALVE: '4',
  SENSOR: '5',
  DATA_LOGGER: '6',
  OTHER: '7'
}

export const RIDERECT_REF_CODE_NOTI = {
  TICKET: 'WFM_TICKET'
}

export const BTN_REDIRECT_LIST = [
  { label: 'Ghi - Thu', page: RouterName.FIELDWORK_ROUTES },
  { label: 'Công việc hiện trường', page: RouterName.FIELDWORK_TICKET_MANAGE }
]

export const METER_TYPE_LIST = [
  { label: 'Đồng hồ DMA', value: 'DMA' },
  { label: 'Đồng hồ nguồn cấp', value: 'SOURCE' }
]

export const APPLICATION_SUBSYSTEM = [
  { label: 'Quản lý mạng lưới / Công việc hiện trường', value: 0 },
  { label: 'CRM / Hỗ trợ', value: 1 }
]

export const OBJECT_TYPE_TICKET = {
  CRM_CUSTOMER: 1,
  PIPE: 2,
  MASTER_METER: 3,
  VALVE: 4,
  SENSOR: 5,
  DATALOGGER: 6,
  OTHER: 7
}

export const DEVICE_TYPE = {
  MASTER_METER: '1',
  VALVE: '2',
  SENSOR: '3',
  DATALOGGER: '4'
}

export const CODE_ROLE_LIST = {
  TECHNICIAN: 'QLML_KTV',
  QLML_TN: 'QLML_TN',
  QTHT_CC: 'QTHT_CC',
  QLML_QLCT: 'QLML_QLCT'
}

export const PIPE_STATE_LIST = [
  {
    value: '4',
    name: 'Đang sử dụng'
  },
  {
    value: '5',
    name: 'Không sử dụng'
  },
  {
    value: '1',
    name: 'Chưa lắp đặt'
  },
  {
    value: '2',
    name: 'Đang lắp đặt'
  }
]

export const PIPE_STATE_VALUE = {
  NOT_INSTALLED: 1,
  INSTALLING: 2,
  IN_USE: 4,
  NOT_IN_USE: 5
}
export const PIPE_WATER_TYPE = {
  TREATED: 1,
  RAW: 2
}

export const PIPE_WATER_TYPE_LIST = [
  {
    name: 'Tuyến nước sạch',
    value: '8'
  },
  {
    name: 'Tuyến nước thô',
    value: '9'
  }
]

export const INCLUDE_DMX_CHILD_LIST = [
  { label: 'Không', value: false },
  { label: 'Có', value: true }
]

export const RAW_PIPE_COLOR = '#78716c'

export const NORM_TYPE = {
  LABOR_UNIT_PRICE: 1,
  COST_ESTIMATE: 2
}

export const STATE_CONFIRM = {
  CONFIRM: 1,
  UN_CONFIRM: 0
}

export const STATUS = {
  ACTIVE: 1,
  INACTIVE: 0
}

export const METER_C_STATUS_LIST = [
  { title: 'Hoạt động', value: 1 },
  { title: 'Ngưng hoạt động', value: 0 }
]
